export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '黄游下戟是什么意思？',
    answer: '黄游下戟是中国古代的一个经典典故。"黄游"是一位春秋时期贤士的名字，"下戟"意为放下手中的长戟（古代兵器）。这个典故象征着放下武力与争强好胜之心，选择清静自守、超然物外的人生态度。它体现了中国传统文化中"不慕荣利""以退为进"的智慧。',
  },
  {
    id: 'faq-2',
    question: '黄游下戟的典故出自哪部古籍？',
    answer: '黄游下戟的早期雏形可以追溯到先秦时期的《庄子》和《楚辞》，其中关于"游"的哲学阐释为其奠定了思想基础。作为一个完整的典故表达，它在汉代刘向《说苑》和班固《汉书·艺文志》中有相关记载，并在魏晋时期的《世说新语》中得到广泛引用和定型。',
  },
  {
    id: 'faq-3',
    question: '黄游下戟有什么文化寓意？',
    answer: '黄游下戟具有多重文化寓意：首先，"戟"象征武力与争伐，"下戟"代表放下暴力、拒绝争强好胜；其次，它象征着不慕荣利、超然物外的士人精神；第三，它体现了道家"无为而无不为"的哲学智慧。这一典故已经超越了其历史故事的范畴，成为中国文化中一种重要的精神象征。',
  },
  {
    id: 'faq-4',
    question: '黄游下戟在后世文学中有哪些传承？',
    answer: '黄游下戟在历代文学中有着广泛的传承。唐代诗人李白、杜甫、王维都在各自的诗作中化用过这一典故的精神内涵；宋代词人苏轼、辛弃疾、李清照也以不同的方式将其融入词作；历代书画家如顾恺之、倪瓒、八大山人也通过视觉艺术对这一典故进行了独特的诠释。',
  },
  {
    id: 'faq-5',
    question: '黄游下戟在现代社会有什么意义？',
    answer: '在当今快节奏、高压力的社会环境中，黄游下戟所代表的"适时放下"的智慧具有极强的现实意义。它提醒现代人在追求物质成就的同时，也要学会放下不必要的负担和执念，保持内心的宁静与精神的自由。这一古老典故为当代人应对"内卷"和焦虑提供了一种有益的思考路径。',
  },
];